import React, { useContext, useEffect } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBasePath } from "../../utils";
import ecoImg from "../../assets/img/store/eco.jpg";
import primeImg from "../../assets/img/store/prime.jpg";
import goldImg from "../../assets/img/store/gold.jpg";
import { maybeAutoLoginFromQuery } from "../autoLogin";
import { AppContext } from "../../context";

const StoreCollectionsList = () => {
  const basePath = getBasePath();
  const location = useLocation();
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(AppContext) || {};

  useEffect(() => {
    maybeAutoLoginFromQuery({ location, navigate, setCurrentUser });
  }, [location, navigate, setCurrentUser]);

  const staticCollections = [
    {
      id: "eco",
      name: "Eco",
      image: ecoImg,
    },
    {
      id: "prime",
      name: "Prime",
      image: primeImg,
    },
    {
      id: "gold",
      name: "Gold",
      image: goldImg,
    },
  ];

  return (
    <div className="catalog-products-list-container">
      <style>
        {`
          .collection-card-hover {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .collection-card-hover:hover {
            transform: translateY(-8px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
          }
        `}
      </style>
      <Container>
        <h2 className="mt-4 text-center fs-35px">Products</h2>

        <Row className="g-5">
          {staticCollections.map((collection) => (
            <Col key={collection.id} xs={12} md={4} className="mt-4">
              <Link
                to={`${basePath}/store/collections/${collection.id}`}
                className="text-decoration-none text-reset"
              >
                <Card className="h-100 shadow-sm collection-card-hover">
                  {collection.image && (
                    <div className="w-100">
                      <img
                        src={collection.image}
                        alt={collection.name}
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                  )}
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoreCollectionsList;

